// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2eZp3","modalFooterButton":"ModalNotes_modalFooterButton__F8rxK"};